// extracted by mini-css-extract-plugin
module.exports = {"Container":"Books_Container__FRZgV","Heading":"Books_Heading__hCLjj","Books":"Books_Books__yf2oY","Book":"Books_Book__2ID4I"};